// extracted by mini-css-extract-plugin
module.exports = {"input":"InputNumber_input__xo6o9","disabled":"InputNumber_disabled__2bZ9O"};